import { FormEvent, useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import { Delete } from "@material-ui/icons";
import Dialog from "@material-ui/core/Dialog";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Typography from "@material-ui/core/Typography";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import { useServiceDeleteStyles } from "./styles";
import { useAttendanceLocalDepartmentQueueServiceTimeDelete } from "../../../../../../../../../../../../../../../services/api-tansquery/attendance-local/department/queue/service-time/delete";
import { useAttendanceLocalStyles } from "../../../../../../../../../../../../../styles";
import { AttendanceLocalDepartmentQueueServiceTime } from "../../../../../../../../../../../../../../../@types/attendance-local-department-queue-service-time";

type ServiceDeleteProps = {
  service: AttendanceLocalDepartmentQueueServiceTime;
  buttonTrigger?: React.ReactNode;
}

export default function ServiceHourDelete({ service, buttonTrigger }: ServiceDeleteProps) {
  const [open, setOpen] = useState(false);
  const { classes } = useServiceDeleteStyles();
  const { classes: defaultClasses } = useAttendanceLocalStyles();
  const mutation = useAttendanceLocalDepartmentQueueServiceTimeDelete();

  async function handleSubmit(event: FormEvent<HTMLDivElement>) {
    event.preventDefault();

    if (mutation.isLoading) {
      return;
    }

    await mutation.mutateAsync(service.id);
  }

  useEffect(() => {
    if (mutation.isSuccess) {
      setOpen(false);
    }
  }, [mutation.isSuccess]);

  return (
    <>
      {buttonTrigger ? (
        <span onClick={() => setOpen(true)} className={classes.menuItem}>
          {buttonTrigger}
        </span>
      ) : (
        <Button
          startIcon={<Delete />}
          className={defaultClasses.addButton}
          onClick={() => setOpen(true)}
        >
          Remover
        </Button>
      )}
      <Dialog open={open} maxWidth="sm">
        <Card component="form" onSubmit={handleSubmit}>
          <CardHeader
            avatar={<Delete />}
            className={classes.cardHeader}
            title={
              <Typography variant="h5">Remover Configuração</Typography>
            }
          />
          <CardContent className={classes.cardContent}>
            <Typography className={classes.textWarning}>
              Você está prestes a remover a configuração de tempo do serviço <strong>{service.servico?.servico?.titulo}</strong> do sistema.
            </Typography>
            <Typography className={classes.textWarning}>
              Tem certeza que deseja continuar?
            </Typography>
          </CardContent>
          <CardActions className={classes.cardActions}>
            <Button
              className={classes.button}
              onClick={() => setOpen(false)}
              disabled={mutation.isLoading}
            >
              Cancelar
            </Button>
            <Button
              type="submit"
              className={classes.duplicateButton}
              disabled={mutation.isLoading}
            >
              {mutation.isLoading ? 'Removendo...' : 'Remover'}
            </Button>
          </CardActions>
        </Card>
      </Dialog >
    </>
  );
}
